import React, {useState} from 'react';
import {connect} from 'react-redux';
import {Select} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import css from './LayersPanel.module.css';
import FormControl from "@material-ui/core/FormControl";
import * as filterActions from "../../../../store/filterSlice";
import pokedex from "../../../../utils/pokedex";
import ReactSelect from "react-select";
import {fetchData} from "../../../../store/coreSlice";
import {getPokemonIcon} from "../../../../utils";


const PokemonControls = (props) => {
	const [search] = useState('');
	const options = pokedex.map(p => {return {value: p.pokemon_id, label: p.name}; }); ///*.filter(p => +p.gen <= 5)*/

	const onChangePokemonQuality = (event) => {
		props.setPokemonQuality(event.target.value);
	};

	const onPokemonSelected = (pokemon) => {
		console.log("Selected ", pokemon);
		props.addPokemonSpecies(pokemon.value);
	};

	const filterOptions = (candidate, input) => {
		if( !candidate.label ) {
			console.log("WUT", candidate);
			return;
		} else {
			console.log("Good", candidate);
		}
		return candidate.label.toLowerCase().startsWith(input.toLowerCase());
	};

	return (
		<div className={css.Panel}>
			<div className={css.Title}>Pokemon</div>
			<FormControl className={css.FormElement}>
				<InputLabel>Spawn Quality</InputLabel>
				<Select value={props.pokemonQuality} onChange={onChangePokemonQuality}>
					<MenuItem value="80">Best Spawns</MenuItem>
					<MenuItem value="60">Great Spawns</MenuItem>
					<MenuItem value="40">Good Spawns</MenuItem>
					<MenuItem value="20">Okay Spawns</MenuItem>
					<MenuItem value="90">Spawns With IVs</MenuItem>
					<MenuItem value="0">All Spawns</MenuItem>
				</Select>
				<FormHelperText>Based on meta/rarity/IVs</FormHelperText>
			</FormControl>

			<div className={css.FormElement}>
				<div>Species filter:</div>
				<ReactSelect
					value={search}
					options={options}
					onChange={onPokemonSelected}
					filterOption={filterOptions}
					placeholder="Choose Pokemon..." />

				{props.pokemonSpecies.length > 0 &&
					(<div>
						{props.pokemonSpecies.map(pokemonId => {
							return <img style={{height: 30}} onClick={() => props.removePokemonSpecies(pokemonId)} key={'pokemonIcon-' + pokemonId} src={getPokemonIcon(pokemonId)} alt={'Pokemon #' + pokemonId} />
						})}

						<div><Button size='small' variant='contained' onClick={props.clearPokemonSpecies}>Clear Pokemon Filter</Button></div>
					</div>)
				}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		pokemonQuality: state.filter.pokemonQuality,
		pokemonSpecies: state.filter.pokemonSpecies
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		//	NAME: (value) => dispatch(FN(value)),
		setPokemonQuality: (val) => dispatch(filterActions.setPokemonQuality(val)),
		addPokemonSpecies: (pokemonId) => dispatch(filterActions.addPokemonSpecies(pokemonId)),
		removePokemonSpecies: (pokemonId) => dispatch(filterActions.removePokemonSpecies(pokemonId)),
		clearPokemonSpecies: () => dispatch(filterActions.clearPokemonSpecies()),
		fetchData: (onlyNew) => dispatch(fetchData(onlyNew)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PokemonControls);